
      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("4tVXT", function(module, exports) {
module.exports = JSON.parse("{}");

});


//# sourceMappingURL=en-GB.70cd0dcf.js.map
